import { render, staticRenderFns } from "./PopUpArchiveFile.vue?vue&type=template&id=9d0e9e6c&scoped=true&"
import script from "./PopUpArchiveFile.vue?vue&type=script&lang=js&"
export * from "./PopUpArchiveFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpArchiveFile.vue?vue&type=style&index=0&id=9d0e9e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0e9e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d0e9e6c')) {
      api.createRecord('9d0e9e6c', component.options)
    } else {
      api.reload('9d0e9e6c', component.options)
    }
    module.hot.accept("./PopUpArchiveFile.vue?vue&type=template&id=9d0e9e6c&scoped=true&", function () {
      api.rerender('9d0e9e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpArchiveFile.vue"
export default component.exports